import React, { useState, useEffect } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { SetCompanyUsersFormDataAction, GetCompanyUsersDetailsAction } from "../../../redux/actions/companyAction";
import { useDispatch, useSelector } from "react-redux";

function CompanyUsers({ companyId }) {
    const [loading, setloading] = useState([]);
    const [selectedRow, setselectedRow] = useState([]);
    const dispatch = useDispatch();

    const onRowSelect = (event) => {
        dispatch(SetCompanyUsersFormDataAction(event.data));
    };

    const companyUserDetails = useSelector((state) => state.companySlice?.companyUserDetails);

    const getCompanyUsersDetail = async () => {
        await dispatch(GetCompanyUsersDetailsAction("zbizgateway/nonFin/getUser/" + companyId));
    };

    useEffect(() => {
        if (companyUserDetails !== null || companyUserDetails !== undefined) {
            setloading(false);
        }
    }, [companyUserDetails]);

    useEffect(() => {
        getCompanyUsersDetail();
    }, []); // eslint-disable-line

    const statusTemplate = (rowData) => {
        return (
            <React.Fragment>
                <span className={rowData.isActive === "Y" ? "p-badge p-badge-success" : "p-badge p-badge-danger"}>{rowData?.isActive === "Y" ? "Active" : "Inactive"}</span>
            </React.Fragment>
        );
    }
    return (
        <div>
            <div className="card p-datatable-sm">
                <DataTable selection={selectedRow} onSelectionChange={(e) => setselectedRow(e.value)} selectionMode="single" dataKey="userId" onRowSelect={onRowSelect} loading={loading} paginator rows={5} value={companyUserDetails} emptyMessage="No data found." autoLayout>
                    <Column filter field="designation" header="Designation" />
                    <Column filter field="contactNo" header="Contact no" />
                    <Column filter field="email" header="Email/User Name" />
                    <Column filter field="employeeNo" header="Employee No." />
                    {/* <Column filter field="userName" header="User Name" /> */}
                    <Column filter field={(item) => item.tblUserRoles[0].tblRole.roleName} header="Role" />
                    <Column field="status" filterField={(rowData) => rowData?.isActive === "Y" ? "Active" : "Inactive"} header="Status" body={statusTemplate} filter filterMatchMode="contains" />
                </DataTable>
            </div>
        </div>
    );
}

export default CompanyUsers;
